module.exports = __webpack_public_path__ + "static/media/ShuffleboardBkgSplash.115e8c23.png";